




















// This component fetches a list of stories and displays them as a list of StoryComponent's
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TokenUser } from '../TokenUser'
import * as utils from '../utils';
import * as utils_time from '../utils_time';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { globalUC } from '../UserCache'
import MomentActivityListComponent from '@/components/MomentActivityListComponent.vue';
import { Activity, actionTypes, sortOrderTypes } from '@/Activity'

const DEBUGGING: boolean = false

@Component({
  name: 'MomentActivityFeedComponent',
  components: { MomentActivityListComponent }
})
export default class MomentActivityFeedComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public momentID: number = null;
  public activities: Activity[] = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): TokenUser { return this.$store.getters.isAuthenticated }
  public get siteName(): string { return 'LiveToken' }
  public get siteDomain(): string { return utils.getCurrentHostname() }

  public onOK() {
    this.$emit('close', true)
  }

  public async onShow(dynamicProps: any) {
    if (dynamicProps) {
      if (dynamicProps.momentID) this.momentID = dynamicProps.momentID
    }
    await this.fetchData()
  }

  private async fetchData(calledByInfiniteHandlerOrTimer?: boolean): Promise<number> {
    const header: Activity = new Activity(null)
    header.momentID = 0
    header.date = new Date()

    if (!this.momentID) return 0
    let url: string = utils.getURLprefix() + `/api/topshot/momentActivities/`;
    url += this.momentID

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`MomentActivityFeed.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // load up the activities
      let newRawItems: Activity[] = response.data.activities
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new Activity(po))
        this.activities = [ header ].concat(newRawItems);
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }
    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.activities.length} moments}`)
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // if (this.$store.state.devmode) console.dir(this.u)
    await this.fetchData()
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
